import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "guide-cta" }
const _hoisted_2 = { class: "guide-cta__modal" }
const _hoisted_3 = { class: "guide-cta__body" }
const _hoisted_4 = { class: "guide-cta__loading" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Trigger button "),
    _createVNode(_component_v_btn, {
      class: "guide-cta__trigger",
      variant: "flat",
      "aria-label": "What's new",
      onClick: $setup.openGuide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          color: "#424242",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("mdi-lightbulb-on-outline", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-weight-large" }, "What's new?", -1 /* CACHED */))
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Guide modal "),
    _createVNode(_component_v_dialog, {
      modelValue: $setup.isOpen,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.isOpen) = $event)),
      persistent: "",
      transition: "dialog-bottom-transition",
      width: $setup.DIALOG_WIDTH,
      "content-class": "guide-cta__dialog-content",
      class: "guide-cta__dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              icon: "",
              size: "x-small",
              color: "white",
              class: "guide-cta__close",
              "aria-label": "Close guide",
              onClick: $setup.closeGuide
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-close", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode(" Loading overlay (hidden when iframe has loaded) "),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_progress_linear, {
                indeterminate: "",
                color: "mpBlue",
                class: "guide-cta__progress"
              })
            ], 512 /* NEED_PATCH */), [
              [_vShow, $setup.isLoading]
            ]),
            ($setup.isOpen)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  src: $props.guideUrl,
                  class: "guide-cta__iframe",
                  title: "Workflow guide",
                  onLoad: $setup.onIframeLoad
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}